import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import "../Responsive.css";

import PO_RM from "./PO_Raw_material/PO_raw_material";
import PO_Supplies from "./PO_Supplies/PO_Supplies";
import Other_Expenses from "./Other_Expenses.js/Other_Expenses";
import Received_raw_material from "./PO_Raw_material/Received_raw_material";
import Received_PO_Supplies from "./PO_Supplies/Received_PO_Supplies";
import History_Received_raw_Material from "./PO_Raw_material/History_Received_raw_Material.js";
import History_Received_Supplies from "./PO_Supplies/History_Received_Supples.js";
import History_OtherExpenses from "./Other_Expenses.js/History_OtherExpenses.js";
import { Link } from "react-router-dom";
import { Data_Supply } from "./Pivot_supply_chain/Pivot.js";
import Open_orders_supplychain from "./Open_orders_supplychain/Open_orders_supplychain.js";

const Sidebar_SuppluChain = () => {
  const [RM, setRM] = useState(false);
  const [Supplies, setSupplies] = useState(false);
  const [Expenses, setExpenses] = useState(false);
  const [R_RM, setR_RM] = useState(false);
  const [HR_RM, setHR_RM] = useState(false);
  const [HR_supplies, setHR_supplies] = useState(false);
  const [HExpenses, setHExpenses] = useState(false);
  const [R_supplies, setR_supplies] = useState(false);
  const [animation, setAnimation] = useState(true);

  const [supply_pivot, setsupply_pivot] = useState(false);
  const [Open_order, setOpen_order] = useState(false);

  const [Area, setArea] = useState("WELCOME");

  const userName = (window.localStorage.getItem("Name") || "").replace(/[{""}]/g, "");

  useEffect(() => {
    // reset all
    setRM(false);
    setSupplies(false);
    setExpenses(false);
    setR_RM(false);
    setR_supplies(false);
    setHR_RM(false);
    setHR_supplies(false);
    setHExpenses(false);
    setsupply_pivot(false);
    setOpen_order(false);

    if (Area === "PO RAW MATERIAL") {
      setRM(true);
      setAnimation(false);
    } else if (Area === "PO SUPPLIES") {
      setSupplies(true);
      setAnimation(false);
    } else if (Area === "OTHER EXPENSES") {
      setExpenses(true);
      setAnimation(false);
    } else if (Area === "RECEIVED RAW MATERIAL") {
      setR_RM(true);
      setAnimation(false);
    } else if (Area === "RECEIVED SUPPLIES") {
      setR_supplies(true);
      setAnimation(false);
    } else if (Area === "HISTORY RAW MATERIAL") {
      setHR_RM(true);
      setAnimation(false);
    } else if (Area === "HISTORY SUPPLIES") {
      setHR_supplies(true);
      setAnimation(false);
    } else if (Area === "HISTORY OTHER EXPENSES") {
      setHExpenses(true);
      setAnimation(false);
    } else if (Area === "PIVOT TABLE") {
      setsupply_pivot(true);
      setAnimation(false);
    } else if (Area === "OPEN ORDERS") {
      setOpen_order(true);
      setAnimation(false);
    } else if (Area === "WELCOME") {
      setAnimation(true);
    }
  }, [Area]);

  const handleSelect = (selectedArea) => setArea(selectedArea);

  return (
    <div className="scPage">
      {/* Sidebar */}
      <aside className="scSidebar">
        <div className="scSidebar__brand">
          <div className="scSidebar__brandTitle">Supply Chain</div>
          <div className="scSidebar__brandSub">Realform</div>
        </div>

        <ul className="scNav">
          <li className={`scNav__item ${Area === "PO RAW MATERIAL" ? "isActive" : ""}`} onClick={() => handleSelect("PO RAW MATERIAL")}>
            PO RAW MATERIAL
          </li>
          <li className={`scNav__item ${Area === "PO SUPPLIES" ? "isActive" : ""}`} onClick={() => handleSelect("PO SUPPLIES")}>
            PO SUPPLIES
          </li>
          <li className={`scNav__item ${Area === "OTHER EXPENSES" ? "isActive" : ""}`} onClick={() => handleSelect("OTHER EXPENSES")}>
            OTHER EXPENSES
          </li>
          <li className={`scNav__item ${Area === "RECEIVED RAW MATERIAL" ? "isActive" : ""}`} onClick={() => handleSelect("RECEIVED RAW MATERIAL")}>
            RECEIVED RAW MATERIAL
          </li>
          <li className={`scNav__item ${Area === "RECEIVED SUPPLIES" ? "isActive" : ""}`} onClick={() => handleSelect("RECEIVED SUPPLIES")}>
            RECEIVED SUPPLIES
          </li>
          <li className={`scNav__item ${Area === "HISTORY OTHER EXPENSES" ? "isActive" : ""}`} onClick={() => handleSelect("HISTORY OTHER EXPENSES")}>
            HISTORY OTHER EXPENSES
          </li>
          <li className={`scNav__item ${Area === "PIVOT TABLE" ? "isActive" : ""}`} onClick={() => handleSelect("PIVOT TABLE")}>
            PIVOT TABLE
          </li>
          <li className={`scNav__item ${Area === "OPEN ORDERS" ? "isActive" : ""}`} onClick={() => handleSelect("OPEN ORDERS")}>
            OPEN ORDERS
          </li>
        </ul>
      </aside>

      {/* Main */}
      <main className="scMain">
        <div className="scTopbar">
          <div className="scTopbar__left">
            <h1 className="scTitle">{Area}</h1>
            <div className="scTitleLine" />
          </div>

          <div className="scTopbar__right">
            <Link to="/rawmaterial" className="scBtnLink">
              <button className="scBtn">Raw Material Dataset</button>
            </Link>

            <div className="scUserPill" title={userName}>
              {userName}
            </div>
          </div>
        </div>

        {animation ? (
          <div className="scWelcome">
            <div className="scWelcome__title">Realform Supply Chain</div>
            <div className="scWelcome__sub">Select a section from the left menu to continue.</div>
          </div>
        ) : null}

        {/* Content */}
        <div className="scContent">
          {RM ? <PO_RM /> : null}
          {Supplies ? <PO_Supplies /> : null}
          {Expenses ? <Other_Expenses /> : null}
          {R_RM ? <Received_raw_material /> : null}
          {R_supplies ? <Received_PO_Supplies /> : null}
          {HR_RM ? <History_Received_raw_Material /> : null}
          {HR_supplies ? <History_Received_Supplies /> : null}
          {HExpenses ? <History_OtherExpenses /> : null}
          {supply_pivot ? <Data_Supply /> : null}
          {Open_order ? <Open_orders_supplychain /> : null}
        </div>
      </main>
    </div>
  );
};

export default Sidebar_SuppluChain;
